module.exports = __webpack_public_path__ + "media/images/application/template/search-a4edc4d669179d84326d32a6868ac1e5.svg";